import * as Yup from "yup";

const validationSchema = (schema: any) => {
  const valid = Yup.object({
    username: Yup.string().email(schema.isEmail).required(schema.isRequired),
    password: Yup.string()
      .required(schema.isRequired)
      .test("length", schema.shortPass, (val: any) => {
        return val && val.length >= 5;
      }),
  });
  return valid;
};

export default validationSchema;
